<div class="pagination-container">
  <!-- Rows per page selection -->
  <div class="rows-per-page">
    <label for="rowsSelect">Rows per page:</label>
    <select
      id="rowsSelect"
      [(ngModel)]="pageSize"
      (change)="onSizeChange(pageSize)"
    >
      @for (size of pageOptions; track size) {
        <option [value]="size">{{ size }}</option>
      }
    </select>
  </div>

  <!-- Pagination Controls -->
  <div class="pagination-controls">
    <button
      mat-icon-button
      (click)="onPageChange(1)"
      [disabled]="currentPage === 1"
    >
      <mat-icon>first_page</mat-icon>
    </button>

    <button
      mat-icon-button
      (click)="onPageChange(currentPage - 1)"
      [disabled]="currentPage === 1"
    >
      <mat-icon>chevron_left</mat-icon>
    </button>

    <span class="page-info">Page</span>

    <input
      type="number"
      [(ngModel)]="currentPage"
      (keypress)="handleEnter($event)"
      (blur)="goToPage()"
      [min]="1"
      [max]="totalPages"
      class="page-input"
    />

    <span class="page-info">of {{ totalPages }}</span>

    <button
      mat-icon-button
      (click)="onPageChange(currentPage + 1)"
      [disabled]="currentPage === totalPages"
    >
      <mat-icon>chevron_right</mat-icon>
    </button>

    <button
      mat-icon-button
      (click)="onPageChange(totalPages)"
      [disabled]="currentPage === totalPages"
    >
      <mat-icon>last_page</mat-icon>
    </button>
  </div>
</div>
